import { render, staticRenderFns } from "./DatePicker2Component.vue?vue&type=template&id=6964576e&"
import script from "./DatePicker2Component.vue?vue&type=script&lang=js&"
export * from "./DatePicker2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports